import {ERequestType} from 'shared/types/requests';
import {performRequest, TRequestPromise} from 'shared/utils';

export const fetchPreviewPdfSetting = (): TRequestPromise<'Y' | 'N'> =>
    performRequest<'Y' | 'N'>({
      url: '/property/PDF_PREVIEW_ENABLED',
      method: ERequestType.GET,
});